// extracted by mini-css-extract-plugin
export default {"PvpScreen":"PvpScreen_PvpScreen__8gmjA","wrapper":"PvpScreen_wrapper__gwpvd","smoothAppear":"PvpScreen_smoothAppear__lSj5L"};